import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Es digital?',
  a: 'Sí, accedés de forma inmediata después de la compra. Podés verlo desde tu celular, tablet o computadora y descargarlo si preferís.'
}, {
  q: '¿Sirve para la premenopausia también?',
  a: 'Sí, está diseñado tanto para la pre como la postmenopausia. Las recetas y protocolos se adaptan perfectamente a ambas etapas para equilibrar tus hormonas.'
}, {
  q: '¿Funciona si ya probé otras dietas?',
  a: 'Esto no es una dieta genérica. Es un sistema de alimentación consciente diseñado específicamente para los cambios hormonales de esta etapa, por eso funciona donde otras fallan.'
}, {
  q: '¿Puedo hacerlo a mi ritmo?',
  a: 'Por supuesto. Tenés acceso de por vida para avanzar cuando quieras y consultar las recetas siempre que lo necesites.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 md:py-24 bg-white px-5 border-b border-gray-100" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <div className="text-center mb-10 md:mb-14" data-id="element-57">
          <HelpCircle className="w-10 h-10 text-emerald-400 mx-auto mb-4" data-id="element-58" />
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-59">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-3" data-id="element-60">
          {faqs.map((faq, index) => <div key={index} className={`rounded-2xl overflow-hidden border transition-all duration-300 ${openIndex === index ? 'border-emerald-200 shadow-sm' : 'border-gray-100'}`} data-id="element-61">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left focus:outline-none bg-white" data-id="element-62">
                <span className={`text-base md:text-lg font-bold pr-4 ${openIndex === index ? 'text-emerald-900' : 'text-gray-800'}`} data-id="element-63">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-emerald-600 shrink-0" data-id="element-64" /> : <ChevronDown className="w-5 h-5 text-gray-400 shrink-0" data-id="element-65" />}
              </button>

              <AnimatePresence data-id="element-66">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-67">
                    <div className="px-5 md:px-6 pb-5 md:pb-6 text-gray-600 leading-relaxed text-base border-t border-gray-50" data-id="element-68">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}